import { Button } from "antd";
import { RollbackOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

function Reset({
  type = "default",
  icon = <RollbackOutlined />,
  title = "button.reset",
  onClick = () => {},
  id = "btn-reset",
  ...props
}) {
  const { t } = useTranslation();
  const newTitle = title === "button.reset" ? t(title) : title;
  return (
    <Button icon={icon} type={type} onClick={onClick} id={id} {...props}>
      {newTitle}
    </Button>
  );
}

export default Reset;
